import React from "react"
import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

export default function PostTile({ post }) {
  const title = post.title
  const link = post.uri

  const imageData = getImage(
    post.featuredImage?.node?.localFile?.childImageSharp?.gatsbyImageData
  )
  const imageSrc = post.featuredImage?.node?.sourceUrl
  const imageAlt = post.featuredImage?.node?.altText || title

  const shortDesc = post.excerpt

  return (
    <Link
      to={link}
      className="group flex flex-col md:flex-row mb-8 relative border-[4px] border-black rounded-none shadow-[5px_5px_0px_0px_rgba(0,0,0,1)] hover:shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] hover:translate-x-[-3px] hover:translate-y-[-3px] transition-all duration-150"
    >
      {(imageData || imageSrc) && (
        <div className="overflow-hidden md:w-1/3 flex-shrink-0">
          {imageData ? (
            <GatsbyImage
              image={imageData}
              alt={imageAlt}
              className="w-full h-52 md:h-full"
              imgClassName="w-full h-52 md:h-full object-cover transition-all duration-300"
            />
          ) : (
            <img
              src={imageSrc}
              alt={imageAlt}
              className="w-full h-52 md:h-full object-cover transition-all duration-300"
            />
          )}
        </div>
      )}
      <div className="p-5 bg-sky-300 flex flex-col justify-center flex-grow">
        <h2 className="text-2xl mb-2 text-black font-bold border-0">{title}</h2>
        <div
          className="text-sm text-slate-800"
          dangerouslySetInnerHTML={{ __html: shortDesc }}
        />
      </div>
    </Link>
  )
}